import React, { useEffect, FC } from 'react'

import Loading from '../components/system/Loading'

// Sign-in moved to app2. This stub catches client-side transitions to the
// legacy login route (a logout or an expired token inside the legacy app);
// direct hits to / and /login are redirected by nginx before the bundle loads.
// from=legacy tells the v2 page not to bounce a still-valid token straight
// back to /dashboard: the legacy app sends users here when its own boot failed
// (websocket down, api restarting), and forwarding again would reload forever.
const TO = '/v2/login?from=legacy'

const Login: FC<React.PropsWithChildren<unknown>> = () => {
  useEffect(() => {
    window.location.replace(TO)
  }, [])

  return <Loading />
}

export default Login
